/* global Eht */
const validator = {
  // 日期验证
  date(val) {
    return {
      rtn: Eht.Utils.isDate(val),
      text: '请填写格式规范的日期',
    }
  },
  // 传真验证
  fax(val) {
    return {
      rtn: Eht.Utils.isFax(val),
      text: '请填写格式规范的传真号码',
    }
  },
  // 座机验证
  telephone(val) {
    return {
      rtn: Eht.Utils.isTelephone(val),
      text: '请填写格式规范的座机号码',
    }
  },
  // 英文字母验证
  ENName(val) {
    return {
      rtn: Eht.Utils.isEnglishName(val),
      text: '请填写英文内容',
    }
  },
  // 姓名的验证（包含中国少数民族名族和英文的名族）
  xm(val) {
    const zwm = new RegExp(
      /^([\u4e00-\u9fa5]+[\\.|·]{0,1}[\u4e00-\u9fa5]+)+$/
    ).test(val)
    const ywm = new RegExp(/(^([a-z|A-Z]+[\\.|·]{0,1}[a-z|A-Z]+)+$)/).test(val)
    return {
      rtn: zwm || ywm,
      text: '请填写规范的姓名',
    }
  },
  // 最大长度验证
  maxlength(val, content, obj) {
    const length = content.maxlength
    return {
      rtn: String(val).length <= length * 1,
      text: `填写内容长度应小于${length}位`,
    }
  },
  // 日期时间验证
  datetime(val) {
    return {
      rtn: Eht.Utils.isDatetime(val),
      text: '请填写格式规范的时间',
    }
  },
  // 数字验证
  number(val) {
    return {
      rtn: Eht.Utils.isNumber(val),
      text: '请填写数字',
    }
  },
  // 整数验证
  int(val) {
    return {
      rtn: Eht.Utils.isInt(val),
      text: '请填写整数',
    }
  },
  // 浮点类型
  float(val) {
    return {
      rtn: Eht.Utils.isFloat(val),
      text: '请填写小数',
    }
  },
  // 手机号和固定电话同时验证
  phoneOrTel(val) {
    return {
      rtn: Eht.Utils.isPhoneOrTel(val),
      text: '请填写格式规范的电话号码',
    }
  },
  // Email 验证
  email(val) {
    return {
      rtn: Eht.Utils.isEmail(val),
      text: '请填写格式规范的邮箱',
    }
  },
  // 手机号码验证
  mobile(val) {
    return {
      rtn: Eht.Utils.isMobile(val),
      text: '请填写格式规范的手机号码',
    }
  },
  // 身份证强制验证
  cardNo(val) {
    return {
      rtn: Eht.Utils.isPersonCard(val),
      text: '请填写格式规范的身份证号码',
    }
  },
  // 存的汉字验证
  onlyChinese(val) {
    return {
      rtn: Eht.Utils.isOnlyChinese(val),
      text: '请填写汉字',
    }
  },
  // 是否存在汉字验证
  hasChinese(val) {
    return {
      rtn: Eht.Utils.isHasChinese(val),
      text: '填写内容应包含汉字',
    }
  },
  // 邮政编码
  postcode(val) {
    return {
      rtn: Eht.Utils.isPostcode(val),
      text: '请填写格式规范的邮政编码',
    }
  },
  // 正数数字验证
  positiveNumber(val) {
    return {
      rtn: Eht.Utils.isPositiveNumber(val),
      text: '填写内容应为正数',
    }
  },
  // 正数整数验证
  positiveInt(val) {
    return {
      rtn: Eht.Utils.isPositiveInt(val),
      text: '填写内容应为正整数',
    }
  },
  // 正数浮点类型
  positiveFloat(val) {
    return {
      rtn: Eht.Utils.isPositiveFloat(val),
      text: '填写内容应为正数小数',
    }
  },
  // 不能大于当前时间（日）
  lessThanToday(val) {
    const rtn = Eht.Utils.isDate(val)
    if (rtn === false) {
      return {
        rtn,
        text: '请填写格式规范的日期',
      }
    }
    return {
      rtn: Eht.Utils.isLessThanToday(val),
      text: '日期不应大于当前日期',
    }
  },
  // 正数钱数（2位小数可选）
  positiveMoney(val) {
    return {
      rtn: Eht.Utils.isPositiveMoney(val),
      text: '填写内容应为钱数',
    }
  },
  // 数字自由位数验证
  numeric(val, content) {
    const [t = 0, s = 0] = content.numeric
    return {
      rtn: Eht.Utils.isNumeric(val, [t, s]),
      text: `填写内容小数位数不大于${s}、总位数不大于${t}`,
    }
  },
  // 自定义
  custom(fn) {
    return fn()
  },
}

const validUtil = {
  getValidResult(obj, vld) {
    let nsk = true
    let text = ''
    const value = obj.value
    if (vld && vld.required) {
      if (value === null || $.trim(value) === '') {
        nsk = false
        text = '不能为空'
      } else {
        nsk = true
      }
    }
    if (nsk === true) {
      for (const vn in vld) {
        if (
          vn !== 'required' &&
          validator[vn] &&
          $.trim(value) !== '' &&
          value !== null
        ) {
          const rtn = validator[vn](value, vld, obj)
          nsk = nsk & rtn.rtn
          if (rtn.rtn === false) {
            text = `${text} ${rtn.text}`
          }
        }
      }
    }
    const rtn = nsk
    return { rtn, text }
  },
}

export default validUtil
